import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'

const basePath = '/v-admin/client-admin/job-posting-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    menu: {
      labelI18nKey: 'admin.customer.jobPosterManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.customer.jobPosterManagement.title'
      }
    }
  ]
}
